"use client";

import Link from "next/link";
import { useTranslations } from "@/i18n/LocaleProvider";
import { useSiteNavigation } from "@/lib/useSiteNavigation";
import SocialIcon from "./SocialIcon";

export default function Footer() {
  const { t } = useTranslations();
  const { navLinks, footerLinks, socialLinks } = useSiteNavigation();

  return (
    <footer className="border-t border-foreground/10 bg-background px-8 pb-8 pt-16 text-sm">
      <div className="mx-auto grid max-w-[1440px] grid-cols-1 gap-12 sm:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <p className="font-display text-2xl tracking-tight">{t("header.brand")}</p>
          <p className="mt-3 max-w-xs text-muted">{t("footer.tagline")}</p>
          {socialLinks.length > 0 && (
            <div className="mt-6 flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.url}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.platform}
                  className="flex size-9 items-center justify-center rounded-full border border-foreground/15 text-muted transition hover:border-accent hover:text-accent"
                >
                  <SocialIcon platform={social.platform} />
                </a>
              ))}
            </div>
          )}
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.15em] text-muted">
            {t("footer.exploreHeading")}
          </p>
          <div className="mt-4 flex flex-col gap-2.5">
            {navLinks.map((link) => (
              <Link key={link.href} href={link.href} className="text-foreground/80 hover:text-accent">
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.15em] text-muted">
            {t("footer.legalHeading")}
          </p>
          <div className="mt-4 flex flex-col gap-2.5">
            {footerLinks.map((link) => (
              <Link key={link.href} href={link.href} className="text-foreground/80 hover:text-accent">
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="mx-auto mt-14 max-w-[1440px] border-t border-foreground/10 pt-6 text-muted">
        &copy; {new Date().getFullYear()} {t("footer.rights")}
      </div>
    </footer>
  );
}
